import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-premium";
import { renderDate } from "../../../formatting/dateFormat";
import { standardizeAndMagnifyEffectHtmlImages } from "../../../components/datagrid/renderers/htmlColumn";

export const columns: GridColDef[] = [
  {
    field: "house.upc",
    headerName: "UPC",
    editable: true,
    valueGetter: (value, row) => row.house?.upc,
  },
  {
    field: "house.order_number",
    headerName: "YOM Order Number",
    description: "Internal order number for YOM",
    editable: true,
    valueGetter: (value, row) => row.house?.order_number,
  },
  {
    field: "house.title",
    headerName: "Title",
    editable: false, // Read-only field
    valueGetter: (value, row) => row.house?.title,
  },
  {
    field: "house.price",
    headerName: "Price",
    type: "number",
    editable: true,
    valueGetter: (value, row) => row.house?.price,
    valueFormatter: (value) => {
      if (value === null) return "";
      return `$${Number(value).toFixed(2)}`;
    },
  },
  {
    field: "house.qty",
    headerName: "Open Qty",
    description: "Quantity remaining to be received",
    type: "number",
    editable: true,
    valueGetter: (value, row) => row.house?.qty,
  },
  {
    field: "house.ordqty",
    headerName: "Ordered Qty",
    description: "Quantity that was ordered",
    type: "number",
    editable: true,
    valueGetter: (value, row) => row.house?.ordqty,
  },
  {
    field: "house.supplier",
    headerName: "Supplier",
    editable: true,
    valueGetter: (value, row) => row.house?.supplier,
  },
  {
    field: "house.supplier_order_number",
    headerName: "Supplier Order #",
    editable: true,
    valueGetter: (value, row) => row.house?.supplier_order_number,
  },
  {
    field: "house.notes",
    headerName: "Notes",
    editable: true,
    valueGetter: (value, row) => row.house?.notes,
  },
  {
    field: "house.orderby",
    headerName: "Order By",
    editable: true,
    valueGetter: (value, row) => row.house?.orderby,
  },
  {
    field: "house.activetracking",
    headerName: "Active Tracking",
    editable: true,
    renderCell: (params: GridRenderCellParams) => (
      <span
        onMouseDown={(e) => e.stopPropagation()}
        dangerouslySetInnerHTML={{
          __html: standardizeAndMagnifyEffectHtmlImages(params.value),
        }}
      />
    ),
    valueGetter: (value, row) => row.house?.activetracking,
  },
  {
    field: "house.gottentracking",
    headerName: "Gotten Tracking",
    editable: true,
    renderCell: (params: GridRenderCellParams) => (
      <span
        onMouseDown={(e) => e.stopPropagation()}
        dangerouslySetInnerHTML={{
          __html: standardizeAndMagnifyEffectHtmlImages(params.value),
        }}
      />
    ),
    valueGetter: (value, row) => row.house?.gottentracking,
  },
  {
    field: "house.adddate",
    headerName: "Add Date",
    type: "date",
    valueGetter: (value, row) => row.house?.adddate,
    valueFormatter: (value) => {
      return value ? renderDate(value) : null;
    },
  },
  {
    field: "house.received",
    headerName: "Received",
    type: "date",
    valueGetter: (value, row) => row.house?.received,
    valueFormatter: (value) => {
      return value ? renderDate(value) : null;
    },
  },
];
